<template>
    <div class="treeBox column" v-if="tabData.length > 0">
        <!-- logo -->
        <el-image :src="require('@/assets/icon/logo.png')" fit="cover" class="logo"></el-image>
        <!-- tab 切换 -->
        <div class="treeTabList between">
            <div :class="['treeTabItem center',active == index ? 'treeTabItemOn' : '']" v-for="(item,index) in tabData" :key="index" @click="treeTabTap(index)">
                <el-image :src="item.icon" fit="cover" class="tabIcon"></el-image>
                <span class="tabName">{{ item.name }}</span>
            </div>
        </div>
        <!-- 大模型数据 -->
        <div class="dreamerList column" v-if="tabData[active].id  == '1'">
            <div :class="['dreamerItem flex',tabData[active].active == index ? 'dreamerItemOn' : '']" v-for="(item,index) in tabData[active].cate" :key="index" @click="dreamerTap(index)">
                <el-image :src="item.pcimg" fit="cover" class="dreamerImg"></el-image>
                <div class="dreamerInfo">
                    <div class="dreamerName">{{ item.name }}</div>
                    <div class="dreamerTitle twoRow">{{ item.titlepc }}</div>
                </div>
            </div>
        </div>
        <!-- GEO数据 -->
        <div class="dreamerList column" v-if="tabData[active].id  == '2'">
            <div class="geoItem" v-for="(item,index) in tabData[active].cate" :key="index">
                <div class="geoOneName" v-if="item.name != ''">{{ item.name }}</div>
                <div :class="['geoTwoBox align',tabData[active].active == index && tabData[active].cate[tabData[active].active].active == ii ? 'geoTwoBoxOn' : '']" v-for="(el,ii) in item.data" :key="ii" @click="geoTap(index,ii)">
                    <el-image :src="el.icon" fit="cover" class="geoTwoImg"></el-image>
                    <div class="geoTwoName">{{ el.name }}</div>
                </div>
            </div>
        </div>
        <!-- 个人中心数据 -->
        <div class="myDataBox between">
            <el-image :src="myData.avatar" fit="cover" class="myDataImg"></el-image>
            <div class="myDataInfo">
                <div class="myDataName">{{ myData.nickname }}</div>
                <view class="myVip center" v-if="myData.level && myData.level != ''">
                    <el-image :src="myData.levelicon" fit="cover" class="myVipIcon"></el-image>
                    <view class="myVipName">{{myData.level}}</view>
                </view>
            </div>
            <div class="myNavPos">
                <div class="myNavBox column">
                    <div class="myAssetList spb">
                        <div class="myAssetBox column" @click="myWorkTap">
                            <div class="assetNum">{{myData.count}}</div>
                            <div class="align">
                                <div class="assetTitle">我的作品</div>
                                <el-image :src="require('@/assets/icon/myNext01.png')" fit="cover" class="assetIcon"></el-image>
                            </div>
                        </div>
                        <div class="myAssetBox column" @click="myPointsTap">
                            <div class="assetNum">{{myData.points}}</div>
                            <div class="align">
                                <div class="assetTitle">我的积分</div>
                                <el-image :src="require('@/assets/icon/myNext01.png')" fit="cover" class="assetIcon"></el-image>
                            </div>
                        </div>
                    </div>
                    <div class="becomeVipBox between" @click="vipTap" v-if="myData.vip">
                        <el-image :src="myData.vip.img" fit="cover" class="becomeVipIcon"></el-image>
                        <div class="becomeVipText">
                            <div class="becomeVipTitle oneRow">{{myData.vip.title}}</div>
                            <div class="becomeVipTips oneRow">{{myData.vip.title1}}</div>
                        </div>
                        <el-image :src="require('@/assets/icon/myNext02.png')" fit="cover" class="becomeIcon"></el-image>
                    </div>
                    <div class="myNavList" v-if="myData.list">
                        <div class="myNavItem between" v-for="(item,index) in myData.list" :key="index" @click="myNavTap(item)">
                            <div class="align">
                                <el-image :src="item.img" fit="cover" class="navIcon"></el-image>
                                <div class="navTitle oneRow">{{item.title}}</div>
                            </div>
                            <div class="align">
                                <div class="navTips oneRow" v-if="item.title1 != ''">{{item.title1}}</div>
                                <el-image :src="require('@/assets/icon/myNext03.png')" fit="cover" class="navNext"></el-image>
                            </div>
                        </div>
                        <div class="myNavItem between" @click="logoutTap">
                            <div class="align">
                                <el-image :src="require('@/assets/icon/exit.png')" fit="cover" class="navIcon"></el-image>
                                <div class="navTitle oneRow">退出登录</div>
                            </div>
                            <el-image :src="require('@/assets/icon/myNext03.png')" fit="cover" class="navNext"></el-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                userId: 0,
                tabData: [],
                active: 0,
                myData: {},
            }
        },
        mounted(){
            this.userId = localStorage.getItem("userId") || 0
            this.getMyData();
            this.getTab();
        },
        methods: {
             // tab数据
            getTab(){
                this.request.get("index/Category/cate",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    let obj = res.data
                    this.tabData = obj
                     // 数据加载完成后，默认选中第一个并发射事件
                    if(obj[this.active].cate.length > 0 && obj[this.active].id == '1') {
                        this.tabData[this.active].active = 0;
                        this.$emit('dreamerSelected', { 
                            hcid: obj[this.active].cate[0].hcid,
                            tabId: obj[this.active].id
                        });
                    }
                })
            },
            // tab 切换
            treeTabTap(index){
                this.active = index;
                if(this.tabData[index].id == '1'){
                    this.dreamerTap(this.tabData[this.active].active)
                }
                if(this.tabData[index].id == '2'){
                    this.geoTap(this.tabData[this.active].active,this.tabData[this.active].cate[this.tabData[this.active].active].active)
                }
            },
            // 大模型点击
            dreamerTap(index){
                if(this.tabData[this.active].cate[index].urltype == '-1'){
                    this.$message({
                        message: '敬请期待',
                        type: 'warning'
                    });
                    return
                }
                this.tabData[this.active].active = index;
                // 发射选中事件，传递 hcid 和 tabId
                this.$emit('dreamerSelected', { 
                    hcid: this.tabData[this.active].cate[index].hcid,
                    tabId: this.tabData[this.active].id
                });
            },
            // GEO点击
            geoTap(index,ii){
                this.tabData[this.active].active = index;
                this.tabData[this.active].cate[index].active = ii;
                // 发射选中事件，传递 hcid 和 tabId
                this.$emit('dreamerSelected', { 
                    hcid: this.tabData[this.active].cate[index].data[ii].id,
                    tabId: this.tabData[this.active].id
                });
            },
            // 获取个人中心数据
			getMyData(){
                this.request.get("api/user/userinfo",{
                    params:{
                       userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    this.myData = res.data
                })
			},
            // 跳转我的作品
			myWorkTap(){
				
			},
			// 跳转我的积分
			myPointsTap(){
				
			},
            // vip点击
			vipTap(){
				
			},
            // 退出登录
			logoutTap(){
                this.$message({
                    message: '退出登录成功',
                    type: 'success'
                });
                localStorage.removeItem("userId")
                this.$router.push({path: '/login'})
			},
        }
    }
</script>
<style lang="less" scoped>
    .treeBox{
        width: 220px;
        height: 100vh;
        padding: 0 10px;
        .logo{
            max-width: 220px;
            height: 45px;
            margin-top: 15px;
        }
        .treeTabList{
            width: 210px;
            height: 40px;
            padding: 4px;
            background: #F5F6F7;
            border-radius: 16px;
            border: 1px solid #EDEDED;
            margin-top: 8px;
            .treeTabItem{
                &.treeTabItemOn{
                    opacity: 1;
                    background: #fff;
                }
                width: 102px;
                height: 40px;
                border-radius: 16px;
                opacity: 0.55;
                cursor: pointer;
                &:hover{
                    opacity: 1;
                }
                .tabIcon{
                    width: 24px;
                    height: 24px;
                }
                .tabName{
                    font: 14px/18px "Microsoft YaHei";
                    color: #00BF7F;
                }
            }
        }
        .dreamerList{
            width: 220px;
            height: calc(100vh - 220px);
            padding: 8px 0;
            overflow-y: scroll;
            // 隐藏滚动条 (Chrome, Safari, Opera)
            &::-webkit-scrollbar {
                display: none;
            }
            // 隐藏滚动条 (IE, Edge, Firefox)
            -ms-overflow-style: none;  // IE and Edge
            scrollbar-width: none;  // Firefox
            .dreamerItem{
                &.dreamerItemOn{
                    background: rgba(0,0,0,0.05);
                    .dreamerName{
                        color: #000 !important;
                    }
                }
                width: 200px;
                border-radius: 16px;
                margin-top: 4px;
                padding: 10px;
                cursor: pointer;
                &:hover{
                    background: rgba(0,0,0,0.05);
                    .dreamerName{
                        color: #000 !important;
                    }
                }
                .dreamerImg{
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }
                .dreamerInfo{
                    width: 150px;
                    margin-left: 10px;
                    .dreamerName{
                        font: bold 14px/18px "Microsoft YaHei";
                        color: #595959;
                    }
                    .dreamerTitle{
                        max-height: 32px;
                        font: 12px/16px "Microsoft YaHei";
                        color: #8C8C8C;
                        margin-top: 4px;
                    }
                }
            }
            .geoItem{
                width: 220px;
                .geoOneName{
                    width: 180px;
                    padding: 0 20px;
                    font: 12px/22px "Microsoft YaHei";
                    color: #C0C4CC;
                    margin-top: 10px;
                }
                .geoTwoBox{
                    width: 180px;
                    height: 44px;
                    padding: 0 20px;
                    border-radius: 16px;
                    margin-top: 4px;
                    cursor: pointer;
                    &.geoTwoBoxOn{
                        background: rgba(0,0,0,0.05);
                    }
                    &:hover{
                        background: rgba(0,0,0,0.05);
                    }
                    .geoTwoImg{
                        width: 18px;
                        height: 18px;
                    }
                    .geoTwoName{
                        font: 14px/44px "Microsoft YaHei";
                        margin-left: 5px;
                    }
                }
            }
        }
        .myDataBox{
            width: 196px;
            height: 36px;
            padding: 12px;
            background: rgba(0,0,0,0.03);
            border-radius: 8px;
            margin-top: 4px;
            cursor: pointer;
            position: relative;
            z-index: 99;
            &:hover{
                .myNavPos{
                    display: block;
                }
            }
            .myDataImg{
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
            .myDataInfo{
                width: 154px;
                .myDataName{
                    font: bold 14px/18px "Microsoft YaHei";
                }
                .myVip{
                    padding: 0 6px;
                    height: 18px;
                    background: linear-gradient( to right, #FFF0D7 0%, #FDD39A 100%);
                    border-radius: 8px;
                    .myVipIcon{
                        height: 11px;
                    }
                    .myVipName{
                        font: 10px/18px "Microsoft YaHei";
                        color: #4D3329;
                    }
                }
            }
            .myNavPos{
                position: absolute;
                right: -346px;
                bottom: 0;
                padding-left: 20px;
                display: none;
                .myNavBox{
                    width: 302px;
                    padding: 12px;
                    background: #fff;
                    box-shadow: 0 4px 12px 0 rgba(0,0,0,0.08);
                    border-radius: 16px;
                    .myAssetList{
                        width: 302px;
                        .myAssetBox{
                            width: 147px;
                            height: 68px;
                            background: #F8F9FA;
                            justify-content: center;
                            .assetNum{
                                font: 17px/22px "Microsoft YaHei";
                            }
                            .assetTitle{
                                font: 14px/18px "Microsoft YaHei";
                                color: #8C8C8C;
                                margin-top: 4px;
                            }
                            .assetIcon{
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                    .becomeVipBox{
                        width: 280px;
                        height: 62px;
                        padding: 0 10px;
                        background: linear-gradient( to right, #FFE4AA 0%, #FFF4DF 100%);
                        border-radius: 8px;
                        margin-top: 8px;
                        .becomeVipIcon{
                            height: 38px;
                        }
                        .becomeVipText{
                            flex: 1;
                            padding: 0 8px;
                            .becomeVipTitle{
                                font: bold 16px/20px "Microsoft YaHei";
                            }
                            .becomeVipTips{
                                font: 12px/15px "Microsoft YaHei";
                                color: #8B867C;
                                margin-top: 4px;
                            }
                        }
                        .becomeIcon{
                            width: 16px;
                            height: 16px;
                        }
                    }
                    .myNavList{
                        width: 302px;
                        margin-top: 6px;
                        .myNavItem{
                            width: 286px;
                            height: 40px;
                            padding: 0 8px;
                            margin-top: 2px;
                            &:hover{
                                background: rgba(0,0,0,0.05);
                            }
                            .navIcon{
                                width: 24px;
                                height: 24px;
                            }
                            .navTitle{
                                max-width: 160px;
                                font: 14px/18px "Microsoft YaHei";
                                padding: 0 2px;
                            }
                            .navTips{
                                max-width: 80px;
                                font: 12px/15px "Microsoft YaHei";
                                color: #8C8C8C;
                                padding: 0 2px;
                            }
                            .navNext{
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>